import React, { useEffect, useState } from 'react'
import styles from './CustomInput.module.scss'

interface IProps {
  title: string
  placeholder?: string
  onChange: (cap: string, size: string, num: number) => void
  value: string
  type?: string
  typedata?: string
}

export const CustomInput = ({
  title,
  value,
  onChange,
  placeholder,
  type,
  typedata,
}: IProps) => {
  const [state, setState] = useState(value)
  const validation: RegExp = /(?:\+.*)\+|[^\d+]+/g;

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cap = e.target.getAttribute("data-type") as string;
    let val = e.target.value.replace(validation, '')
    
    setState(val)
    onChange(cap, e.target.name, Number(val) > 0 ? Number(val) : 0);
  }

  useEffect(()=>{
    setState(value)
  }, [value])

  return (
    <div className={styles.Wrapper}>
      <div className={`${styles.FormItem} ${Number(state) > 0 && styles.NotEmpty}`}>
          <input
            autoComplete={type === 'email' ? type : "on"}
            name={title}
            type={type ? type : 'text'}
            value={type ? state : Number(state) > 0 ? state : ''}
            onInput={onInputChange}
            data-type={typedata ? typedata : ''}
          />
          <label className={styles.Title}>
            {placeholder}
          </label>
      </div>
    </div>
  )
}
